import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { cyclopsAboutComponent } from './cyclops/cyclops-about/cyclops-about.component';
import { cyclopsBMIComponent } from './cyclops/cyclops-bmi/cyclops-bmi.component';
import { cyclopsBrandComponent } from './cyclops/cyclops-brand/cyclops-brand.component';
import { cyclopsCopyrightComponent } from './cyclops/cyclops-copyright/cyclops-copyright.component';
import { cyclopsCounterComponent } from './cyclops/cyclops-counter/cyclops-counter.component';
import { cyclopsFooterComponent } from './cyclops/cyclops-footer/cyclops-footer.component';
import { cyclopsHeaderComponent } from './cyclops/cyclops-header/cyclops-header.component';
import { cyclopsNavComponent } from './cyclops/cyclops-nav/cyclops-nav.component';
import { cyclopsPricingComponent } from './cyclops/cyclops-pricing/cyclops-pricing.component';
import { cyclopsScheduleComponent } from './cyclops/cyclops-schedule/cyclops-schedule.component';
import { cyclopsTestimonialComponent } from './cyclops/cyclops-testimonial/cyclops-testimonial.component';
import { cyclopsTrainerComponent } from './cyclops/cyclops-trainer/cyclops-trainer.component';
import { cyclopsWorkoutAboutComponent } from './cyclops/cyclops-workout-about/cyclops-workout-about.component';
// cyclops Layout
import { cyclopsComponent } from './cyclops/cyclops.component';
import { LayoutsRoutingModule } from './layouts-routing.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    cyclopsComponent, cyclopsNavComponent, cyclopsHeaderComponent, cyclopsAboutComponent, cyclopsScheduleComponent, cyclopsWorkoutAboutComponent, cyclopsCounterComponent, cyclopsTrainerComponent, cyclopsTestimonialComponent, cyclopsPricingComponent, cyclopsBMIComponent, cyclopsBrandComponent, cyclopsFooterComponent, cyclopsCopyrightComponent
  ],
  imports: [
    CommonModule,
    LayoutsRoutingModule,
    CarouselModule,
    NgbModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    cyclopsNavComponent,
    cyclopsFooterComponent
  ],
})

export class LayoutsModule { }
